import { useMemo } from 'react';

import SectionTitle from '@src/components/elements/SectionTitle';
import { getStrapiMedia } from '@utils/media';

import style from './TradeHomeReviewsV2.module.css';
import CircularGallery from './CircularGallery';
import NextImage from '@src/components/elements/Image';
import Image from 'next/image';

const TradeHomeReviewsV2 = (props) => {
  const data = props.data || props;
  const reviews = useMemo(() => {
    const reviewData = data?.reviews?.data || [];

    return reviewData
      .map((review) => {
        const attributes = review?.attributes || review;
        const imageUrl =
          attributes?.image?.data?.attributes?.url ||
          attributes?.image?.url ||
          attributes?.image_url;

        return {
          id: attributes?.id || review?.id,
          order: attributes?.order,
          name: attributes?.name,
          review: attributes?.review,
          rating: attributes?.rating,
          ratingText: attributes?.rating_text,
          logoUrl: getStrapiMedia(imageUrl),
          reviewUrl: attributes?.review_url,
        };
      })
      .filter((item) => item.name || item.review);
  }, [data]);

  if (!data) return null;

  return (
    <div className={`relative ${style.titleStyling}`}>
      <div className={`${style.topRight} hidden lg:block`}>
        <Image src={'/assets/images/x-right-image.png'} height={214} width={175} alt="" aria-hidden quality={100} />
      </div>
      <div className={`${style.bottomLeft} hidden lg:block`}>
        <Image src={'/assets/images/x-left-image.png'} height={280} width={244} alt="" aria-hidden quality={100} />
      </div>
      <div className='container lg:hidden'>
        <SectionTitle data={data?.section_title} />
      </div>
      <div className='hidden lg:block'>
        <SectionTitle data={data?.section_title} />
      </div>
      <div className={style.galleryWrapper}>
        <div className={style.phoneBg}>
          <Image src={'/assets/images/reviews-phone.png'} height={465} width={340} alt="" aria-hidden quality={100} />
        </div>
        <CircularGallery items={reviews} />
      </div>
    </div>
  );
};

export default TradeHomeReviewsV2;
